import { withChartLayout } from 'components/common';
import HealthHistory from 'components/features/chart/admission-history/health-history/HealthHistory';

const HealthHistoryPage = withChartLayout('Health History')(HealthHistory);
export default HealthHistoryPage;
